function getCanonical (vm) {
  const { canonical } = vm.$options
  if (canonical) {
    return typeof canonical === 'function'
      ? canonical.call(vm)
      : canonical
  }
}
export default {
  created () {
    const canonical = getCanonical(this)
    if (canonical) {
      if (document.querySelector('link[rel=canonical]')) {
        document.querySelector('link[rel=canonical]').setAttribute('href', canonical)
      } else {
        let link = document.createElement('link')
        link.rel = 'canonical'
        link.href = canonical
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    }
  }
}
